import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HealthResolver } from 'src/app/core/resolvers/healthAndLifestyle.resolver';
import { AddMedicalConditionComponent } from './components/medical-conditions/add-medical-condition/add-medical-condition.component';
import { DiabetesComponent, DoctorDetailsComponent } from 'src/app/pages/medical-underwriting';
// tslint:disable-next-line:max-line-length
import { DiabetesMedicalCondtionComponent } from 'src/app/pages/medical-underwriting/components/medical-conditions/diabetes-medical-condtion/diabetes-medical-condtion.component';
// tslint:disable-next-line:max-line-length
import { MedicalConditionComponent } from 'src/app/pages/medical-underwriting/components/medical-conditions/medical-condition/medical-condition.component';
// tslint:disable-next-line:max-line-length
import { ActivitiesOfDailyLivingComponent } from 'src/app/pages/medical-underwriting/components/activities-of-daily-living/activities-of-daily-living.component';
import { LifestyleNewComponent } from './components/lifestyle-new/lifestyle-new.component';
import { HoSummaryUnderwritingComponent } from './components/ho-summary-underwriting/ho-summary-underwriting.component';


const userRoutes: Routes = 
[
  {
    path: 'lifestyle',
    component: LifestyleNewComponent,
    data: {
      breadcrumb: 'lifestyle',
      title: 'Online Quote - Lifestyle'
    }
  },
  {
    path: 'add-medical-condition',
    component: AddMedicalConditionComponent,
    data: {
      breadcrumb: 'amc',
      title: 'Online Quote - Add Medical Condition'
    }
  },
  {
    path: 'medical-condition-content',
    component: DiabetesComponent,
    data: {
      breadcrumb: 'diabetes',
      title: 'Online Quote - Diabetes'
    }
  },
  {
    path: 'medical-condition-questionnaire',
    component: DiabetesMedicalCondtionComponent,
    data: {
      breadcrumb: 'Medical condition questionnaire',
      title: 'Online Quote - MC Questionnaire'
    }
  },
  {
    path: 'doctor\'s-details',
    component: DoctorDetailsComponent,
    data: {
      breadcrumb: 'doctor\'s-details',
      title: 'Online Quote - Annuitant Doctor'
    }
  },
  {
    path: 'medical-conditions',
    component: MedicalConditionComponent,
    data: {
      breadcrumb: 'medical-conditions',
      title: 'Online Quote - MC'
    }
  },
  {
    path: 'activities-of-daily-living',
    component: ActivitiesOfDailyLivingComponent,
    data: {
      breadcrumb: 'doctor-detail',
      title: 'Online Quote - Activities of Daily Living'
    }
  },
  {
    path: 'dependant-lifestyle',
    component: LifestyleNewComponent,
    data: {
      breadcrumb: 'lifestyle',
      title: 'Online Quote - Dependant\'s Lifestyle'
    }
  },
  {
    path: 'dependant-add-medical-condition',
    component: AddMedicalConditionComponent,
    data: {
      breadcrumb: 'amc',
      title: 'Online Quote - Dependant\'s Add MC'
    }
  },
  {
    path: 'dependant-medical-condition-content',
    component: DiabetesComponent,
    data: {
      breadcrumb: 'diabetes',
      title: 'Online Quote - Dependant\'s Diabetes'
    }
  },
  {
    path: 'dependant-medical-condition-questionnaire',
    component: DiabetesMedicalCondtionComponent,
    data: {
      breadcrumb: 'Medical condition questionnaire',
      title: 'Online Quote - Dependant\'s MC Questionnaire'
    }
  },
  {
    path: 'dependant-doctor\'s-details',
    component: DoctorDetailsComponent,
    data: {
      breadcrumb: 'doctor\'s-details',
      title: 'Online Quote - Dependant\'s Doctor'
    }
  },
  {
    path: 'dependant-medical-conditions',
    component: MedicalConditionComponent,
    data: {
      breadcrumb: 'medical-conditions',
      title: 'Online Quote - Dependant\'s MC'
    }
  },
  {
    path: 'dependant-activities-of-daily-living',
    component: ActivitiesOfDailyLivingComponent,
    data: {
      breadcrumb: 'doctor-detail',
      title: 'Online Quote - Dependant\'s Activities'
    }
  },
  {
    path: 'summary',
    component: HoSummaryUnderwritingComponent,
    data: {
      breadcrumb: 'ho-summary',
      title: 'Online Quote - HO Summary'
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(userRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class MedicalUnderwritingRouteModule { }
